// extracted by mini-css-extract-plugin
export default {"wrap":"bindAccount-module--wrap--384Sw","back":"bindAccount-module--back--fITi3","title":"bindAccount-module--title--XgRW0"};